export default "__VITE_ASSET__8b434b97__"